import './App.scss';
import { Route, Routes } from 'react-router-dom';
import Lucky7 from './components/ScratchGames/Lucky7';
import HomePage from './containers/HomePage/Homepage';
import ScratchList from './components/ScratchList/ScratchList';
import UssdInformation from './components/UssdComponent/UssdInformation';
import BingoAlphabet from './components/ScratchGames/BingoAlphabet';
import TourneDeChance from './components/ScratchGames/TourneDeChance';
import BingoSafari from './components/ScratchGames/BingoSafari';
import SportDeChance from './components/ScratchGames/SportDeChance';
import FruitDeChance from './components/ScratchGames/FruitDeChance';
import DoubleMillionaire from './components/ScratchGames/DoubleMillionaire';
import FootyCash from './components/FootyCash/FootyCash';
import SportsBetting from './components/SportsBetting/SportsBetting';
import CafGame from './components/ScratchGames/CafGame';
import LotteryHomePage from './components/LotteryHomePage/LotteryHomePage';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getTokenScratch } from './store/scratchSlice';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTokenScratch());
  }, [dispatch]);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/lotteryGames" element={<LotteryHomePage />} />
        <Route path="/ussdGames" element={<UssdInformation />} />
        <Route path="/scratchGames" element={<ScratchList />} />
        <Route path="/footycash" element={<FootyCash />} />
        <Route path="/sportsbetting" element={<SportsBetting />} />
        <Route path="/caf" element={<CafGame />} />
        <Route path="/bingo-alphabet" element={<BingoAlphabet />} />
        <Route path="/tourne-de-chance" element={<TourneDeChance />} />
        <Route path="/lucky7" element={<Lucky7 />} />
        <Route path="/bingo-safari" element={<BingoSafari />} />
        <Route path="/sport-de-Chance" element={<SportDeChance />} />
        <Route path="/fruit-de chance" element={<FruitDeChance />} />
        <Route path="/double-millionaire" element={<DoubleMillionaire />} />
      </Routes>
    </div>
  );
}

export default App;
